const route = 'https://drlucasorthodontics.com/wp-json'

const api = () => {
  try {
    return route
    // return document.location.hostname === 'localhost' ? route : document.location.protocol
  } catch (e) {
    console.log(e)
  }
}

export default api()



// WEBPACK FOOTER //
// ./src/shared/api/api.js